export default ({ request }) => ({
  /**
   * 样品资料提交统计列表查询
   */
  reportSamplelListApi(data = {}) {
    return request({
      url: "/samplemanage/reportSample/list",
      method: "post",
      data,
    })
  },
})
